import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single", (props) => {
  return (
    <div>
      <ContentBlocks blocks={props.contentNode?.contentBlocks} />
    </div>
  )
})
